export const phone_regex_country_code = /^(((?:\(x?\d+\))|(?:x?\d+))[-.]?)+$/;
export const phone_regex_no_country_code = /^\+?(((?:\(x?\d+\))|(?:x?\d+))[-.]?)+$/;